import FileSaver from 'file-saver'
import XLSX from 'xlsx'

export const handleDownload = (filterVal, tableData, header = filterVal, filename = 'table_export') => {
  import('@/utils/Export2Excel').then(excel => {
    const data = formatJson(filterVal, tableData)
    excel.export_json_to_excel({
      header,
      data,
      filename
    })
  })
}
// 下载方法中，需要用到的格式化json的方法
const formatJson = (filterVal, tableData) => {
  return tableData.map(v =>
    filterVal.map(j => {
      if (j === 'id') { // 此处如没有要格式化的列，可以不用此判断
        // return parseTime(v[j])
        return v[j]
      } else {
        return v[j]
      }
    })
  )
}

// 根据表格dom去解析
export function exportExcel (excelName) {
  try {
    const $e = this.$refs.tabel
    const $table = $e
    const wb = XLSX.utils.table_to_book($table, { raw: true })
    const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
    FileSaver.saveAs(
      new Blob([wbout], { type: 'application/octet-stream' }),
      `${excelName}.xlsx`
    )
  } catch (e) {
    if (typeof console !== 'undefined') console.error(e)
  }
}
